import React from 'react';
import { BodyS } from '../typography';
import type { ITableSortState } from './types';
import { TableSortIcon } from './TableSortIcon';

export interface ITableSortableHeaderLabelProps {
	label: string;
	sortField: string;
	sort: ITableSortState;
	onSort: () => void;
}

function TableSortableHeaderLabel({
	label,
	sortField,
	sort,
	onSort,
}: Readonly<ITableSortableHeaderLabelProps>) {
	return (
		<button
			type="button"
			aria-label={`Sort by ${label}`}
			data-testid={`button-sort-by-${label}`}
			onClick={onSort}
			className="m-0 flex h-full w-full min-w-0 cursor-pointer items-center justify-start border-0 bg-transparent p-0 text-left font-[inherit] text-inherit"
		>
			<span className="inline-flex min-w-0 max-w-full items-center gap-4">
				<BodyS color="primary" className="min-w-0 truncate">
					{label}
				</BodyS>
				<span
					className="inline-flex size-14 shrink-0 items-center justify-center"
					aria-hidden
				>
					<TableSortIcon sortField={sortField} sort={sort} />
				</span>
			</span>
		</button>
	);
}

export { TableSortableHeaderLabel };
